// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader--132MP","load8":"load8--2o_By","small":"small--232nZ","medium":"medium--VaVZ1","large":"large--1GPI3"};